import { render, staticRenderFns } from "./OrderCustomerHistory.vue?vue&type=template&id=8738c1ec"
import script from "./OrderCustomerHistory.vue?vue&type=script&lang=ts"
export * from "./OrderCustomerHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8738c1ec')) {
      api.createRecord('8738c1ec', component.options)
    } else {
      api.reload('8738c1ec', component.options)
    }
    module.hot.accept("./OrderCustomerHistory.vue?vue&type=template&id=8738c1ec", function () {
      api.rerender('8738c1ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/OrderCustomerHistory.vue"
export default component.exports